import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_TABS, REACTIVATION_TAB } from "@components/layout/Navbar";
import { canSeeReactivation } from "@utils/access";

export default function TabSelector({ selected, onSelect }) {
  const navigate = useNavigate();
  const tabs = useMemo(
    () => (canSeeReactivation() ? [...BASE_TABS, REACTIVATION_TAB] : BASE_TABS),
    []
  );

  const renderIcon = (tab, isActive) => {
    const iconClass = `w-5 h-5 transition-colors duration-200 ${isActive ? 'text-teal-400' : 'text-white/50'}`;

    if (tab === "All Patients") {
      return (
        <svg className={iconClass} fill="none" viewBox="0 0 24 24">
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.75"
            d="M4.5 17H4a1 1 0 0 1-1-1 3 3 0 0 1 3-3h1m0-3.05A2.5 2.5 0 1 1 9 5.5M19.5 17h.5a1 1 0 0 0 1-1 3 3 0 0 0-3-3h-1m0-3.05a2.5 2.5 0 1 0-2-4.45m.5 13.5h-7a1 1 0 0 1-1-1 3 3 0 0 1 3-3h3a3 3 0 0 1 3 3 1 1 0 0 1-1 1Zm-1-9.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
          />
        </svg>
      );
    }
    if (tab === REACTIVATION_TAB) {
      return (
        <svg className={iconClass} fill="none" viewBox="0 0 24 24">
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.75"
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      );
    }
    return (
      <svg className={iconClass} fill="none" viewBox="0 0 24 24">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
          d="M15 4h3a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3m0 3h6m-6 5h6m-6 4h6M10 3v4h4V3h-4Z"
        />
      </svg>
    );
  };

  return (
    <div className="bg-white/[0.06] backdrop-blur-sm border border-white/[0.08] px-1.5 py-1.5 flex justify-between items-center rounded-xl w-full gap-1.5">
      {tabs.map((tab) => {
        const isActive = selected === tab;
        return (
          <button
            key={tab}
            onClick={() => (tab === REACTIVATION_TAB ? navigate("/reactivation") : onSelect(tab))}
            className={`flex items-center gap-2 py-2.5 px-4 rounded-lg w-full justify-center transition-all duration-200 ${
              isActive
                ? "bg-gradient-to-b from-white/[0.15] to-white/[0.08] text-white font-semibold shadow-[inset_0_1px_0_rgba(255,255,255,0.15),0_1px_3px_rgba(0,0,0,0.2)]"
                : "text-white/60 hover:text-white/90 hover:bg-white/[0.05]"
            }`}
            style={{ fontFamily: 'var(--font-display)', fontSize: '14px' }}
          >
            {renderIcon(tab, isActive)}
            {tab}
          </button>
        );
      })}
    </div>
  );
}
